<div class="reports-section"></div>
<div class="table-wrapper">
  <div class="table-header gap-4">
    <div class="align-items-center flex">
      <div>
        <button pButton pRipple type="button" [disabled]="loading"
                class="p-button-rounded p-button-text reload-btn" (click)="getReportsList()"></button>
      </div>
      <h2>Reports Management</h2>
      <div class="user-label">
        <img alt="user.svg" src="../../assets/images/reports-m.svg" />
        <span>{{ totalReports }}</span>
      </div>
    </div>

    <div class="align-items-center flex">
      <div class="p-inputgroup table-search-wrapper">
        <span class="p-inputgroup-addon"
          ><img alt="search.svg" src="../../assets/images/search.svg"
        /></span>
        <input
          [(ngModel)]="searchInput"
          (keyup)="onSearchKeyup()"
          class="table-search-field"
          placeholder="Search by Report Name"
          type="text"
        />
      </div>

      <div class="mr-3">
        <div class="field mb-0">
          <div class="p-inputgroup table-calendar-wrapper">
            <span class="p-inputgroup-addon"
              ><img alt="calendar.svg" src="assets/images/calendar.svg"
            /></span>
            <p-calendar
              (onClear)="onCalendarClear()"
              [(ngModel)]="rangeDates"
              [readonlyInput]="true"
              class="w-full"
              dateFormat="{{ datePickerFormat }}"
              inputId="range"
              ngDefaultControl
              [maxDate]="maxDate"
              placeholder="{{ datePickerPlaceholder }}"
              selectionMode="range"
            ></p-calendar>
            <button
              (click)="onCalendarClear()"
              *ngIf="rangeDates != null"
              class="clearBtn"
            >
              <img alt="" src="assets/images/error.svg" />
            </button>
          </div>
        </div>
      </div>
      <p-button
        (click)="performSearch()"   label="Search Reports"
        styleClass="button-sm search-icon"
      ></p-button>
    </div>
  </div>
  <p-table
    #dt
    [rowHover]="true"
    [rowsPerPageOptions]="[10, 20, 30]"
    [rows]="30"
    [showCurrentPageReport]="true"
    [value]="reportsList"
    dataKey="id"
  >
    <p-confirmDialog></p-confirmDialog>
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th class="w-3" id="report-name">Report Name</th>
        <th class="w-2" id="password">Password</th>
        <th class="w-3" id="date-generated">
          Date Generated
        </th>
        <th class="w-3" id="date-range">
          Date Range
        </th>
        <th class="w-3" id="status">Status</th>
        <th class="w-2" id="actions">Actions</th>
      </tr>
    </ng-template>

    <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
      <tr class="p-selectable-row">
        <td class="wrap-text">
          <p class="gc-report-name">{{ rowData.reportName }}</p>
        </td>
        <td>
        <span class="image-text">{{ rowData.showPassword  ? rowData.password : '************' }}</span>
<!--          <i class="pi"-->
<!--            [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"-->
<!--            (click)="togglePassword()"-->
<!--            style="cursor: pointer; margin-left: 8px;"-->
<!--          ></i>-->

          <i
          class="pi"
          [ngClass]="rowData.showPassword ? 'pi-eye-slash' : 'pi-eye'"
          style="cursor: pointer; margin-right: 8px;"
          (click)="togglePasswordVisibility(rowData)"
        ></i>

            <i *ngIf="rowData.showPassword "
            class="pi pi-copy"
            (click)="copyPassword(rowData.password)"
            style="cursor: pointer; margin-left: 8px;"
            title="Copy password"></i>

<!--          {{ rowData.password }}-->
        </td>
        <td class="image-text">
          {{ rowData.createdAt | customDate: dateAndTimeFormat }}
        </td>
        <td class="image-text">
          {{ rowData.searchByDate }}
        </td>
        <td class="image-text" width="135px" [pTooltip]="rowData.reportStatus === 'Failed' ? rowData.description : null"
        tooltipPosition="top">
          <span pTooltip=""></span>
          <span
            [ngClass]="rowData.class"
            class="status-badge"
          >
            <i class="pi" [ngClass]="rowData.icon"></i>
            {{ rowData.reportStatus | titlecase }}
          </span>
        </td>
        <td>
          <div class="flex gap-2"><button
            pButton
            type="button"
            icon="pi pi-download"
            (click)="onDownloadReport($event, rowData)"
            class="download-btn p-button-rounded p-button-text p-button-info"
            [loading]="rowData.isDownloading"
            [disabled]="rowData.reportStatus?.toLowerCase() !== 'processed'"
            pTooltip="{{
              rowData.reportStatus?.toLowerCase() === 'processed'
                ? 'Download Report'
                : 'Report not ready for download'
            }}"
            tooltipPosition="left"
          ></button>

          <button
            pButton
            type="button"
            icon="pi pi-share-alt"
            (click)="onOpenShareSidebar($event, rowData)"
            class="share-btn p-button-rounded p-button-text p-button-help"
            [disabled]="rowData.reportStatus?.toLowerCase() !== 'processed'"
            pTooltip="{{
              rowData.reportStatus?.toLowerCase() === 'processed'
                ? 'Share Report'
                : 'Report not ready for sharing'
            }}"
            tooltipPosition="left"
          ></button>

            <button
              pButton
              type="button"
              icon="pi pi-replay"
              (click)="onRegenerate($event, rowData)"
              class="delete-btn p-button-rounded p-button-text p-button-info"
              [disabled]="rowData.reportStatus?.toLowerCase() !== 'processed'"
              pTooltip="{{
              rowData.reportStatus?.toLowerCase() === 'processed'
                ? 'Regenerate Report'
                : 'Report Not ready for regeneration'
            }}"
              tooltipPosition="left"></button>

            <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-rounded p-button-text p-button-danger"
            [loading]="rowData.isDeleting"
            [disabled]="rowData.isDeleting"
            pTooltip="Delete Report"
            tooltipPosition="left"
            (click)="onDeleteReport($event, rowData)"
          ></button>


          </div>

        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="7" class="text-center">
          <span>
            <em class="pi pi-exclamation-circle mr-2"></em>
            No Report found
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div>
    <p-paginator
      #paginator
      (onPageChange)="paginate($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [rows]="noOfRecordsPerRow"
      [totalRecords]="totalReports"
      styleClass="gc-paginator"
    ></p-paginator>
  </div>
</div>

<p-sidebar
  (onHide)="onCloseShareSidebar()"
  [(visible)]="shareSidebarVisible"
  [showCloseIcon]="false"
  position="right"
>
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
<!--      <h2 *ngIf="!showEditForm" class="gc-form-heading">Add Agency</h2>-->
      <h2 class="gc-form-heading">Share Report</h2>
      <span (click)="onCloseShareSidebar()" class="cursor-pointer"
        ><em class="pi pi-times"></em
      ></span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="popup-wrapper">
      <div class="form-container">
        <form [formGroup]="shareEmailForm">
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Basic Information</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Email<span class="red">*</span></label>
                  <input
                    formControlName="email"
                    id="email"
                    name="email"
                    pInputText
                    placeholder="Enter email to share with"
                    type="text"
                  />
                </div>
                <small
                class="p-error"
                *ngIf="
                  shareEmailForm.get('email')?.touched &&
                  shareEmailForm.get('email')?.invalid
                ">
                Please provide a valid email
              </small>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="gc-slide-footer flex justify-content-end gap-4">
      <button
        (click)="onCloseShareSidebar()"
        class="btn-cancel"
        label="Cancel"
        pButton
        type="submit"
      ></button>
      <button
        (click)="onSubmitShare()"
        [disabled]="shareEmailForm.invalid || isSubmittingShare"
        label="Share"
        [loading]="isSubmittingShare"
        pButton
        type="submit"
      ></button>
    </div>
  </ng-template>
</p-sidebar>

<!--<p-sidebar-->
<!--  [(visible)]="shareSidebarVisible"-->
<!--  position="right"-->
<!--  [showCloseIcon]="false"-->
<!--  (onHide)="onCloseShareSidebar()"-->
<!--&gt;-->
<!--  <ng-template pTemplate="header">-->
<!--    <div class="align-items-center flex justify-content-between w-full">-->
<!--      <h2 class="gc-form-heading">Share Report</h2>-->
<!--      <span (click)="onCloseShareSidebar()" class="cursor-pointer">-->
<!--        <em class="pi pi-times"></em>-->
<!--      </span>-->
<!--    </div>-->
<!--  </ng-template>-->

<!--  <ng-template pTemplate="content">-->
<!--    <div class="popup-wrapper">-->
<!--      <div class="form-container">-->
<!--        <form [formGroup]="shareEmailForm">-->
<!--          <div class="sidebar-form">-->
<!--            <div class="grid p-fluid flex flex-column gap-2">-->
<!--              <div>-->
<!--                <label>Email<span class="red">*</span></label>-->
<!--              </div>-->
<!--              <div class="p-inputgroup w-full input-wrapper">-->
<!--                <input-->
<!--                  pInputText-->
<!--                  formControlName="email"-->
<!--                  placeholder="Enter email to share with"-->
<!--                  class="w-full table-search-field"-->
<!--                />-->
<!--              </div>-->
<!--              <small-->
<!--                class="p-error"-->
<!--                *ngIf="-->
<!--                  shareEmailForm.get('email')?.touched &&-->
<!--                  shareEmailForm.get('email')?.invalid-->
<!--                "-->
<!--              >-->
<!--                A valid email is required-->
<!--              </small>-->
<!--            </div>-->
<!--          </div>-->
<!--        </form>-->
<!--      </div>-->
<!--    </div>-->
<!--  </ng-template>-->

<!--  <ng-template pTemplate="footer">-->
<!--    <div class="gc-slide-footer flex justify-content-end gap-4">-->
<!--      <button-->
<!--        pButton-->
<!--        label="Cancel"-->
<!--        class="btn-cancel"-->
<!--        [disabled]="isSubmittingShare"-->
<!--        (click)="onCloseShareSidebar()"-->
<!--      ></button>-->
<!--      <button-->
<!--        pButton-->
<!--        label="Share"-->
<!--        [disabled]="shareEmailForm.invalid || isSubmittingShare"-->
<!--        [loading]="isSubmittingShare"-->
<!--        (click)="onSubmitShare()"-->
<!--      ></button>-->
<!--    </div>-->
<!--  </ng-template>-->
<!--</p-sidebar>-->
